import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js"; // Function to fetch user data
import {
  getOrgById,
  getOrgByRef,
  transformAppLogsToTable,
  transformLogsToTable,
  transformTicketsToTable,
} from "../../models/OrgFunctions.js"; // Functions to fetch org and client data
import Divider from "../../layout/Divider.js";
import Space from "../../layout/Space.js";
import DataGridFull from "../../tables/DataGridFull.js";
import { Switch, useTheme } from "@mui/material";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import Icon1 from "../../icons/Icon.js";
import {
  getDocDataByRef,
  getFlutterTime,
  queryCollection,
} from "../../models/DataFunctions.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import TextField2 from "../../textfields/TextField2.js";
import deleteDocApi from "../../api/database/deleteDocApi.js";
import { useAppContext } from "../../config/AppContext.js";
import Modal1 from "../../modals/Modal1.js";
import sendPushNotification from "../../api/send/sendPushNotification.js";
import { message } from "antd";
import { Token } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import { set } from "date-fns";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import MLTFGPT1 from "../../textfields/MLTFGPT1.js";
import sendRequestResolved from "../../api/send/sendRequestResolved.js";
function SupportRequests({ navigateWorkspace }) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);
  const [pushOpen, setPushOpen] = useState(false);
  const [title = "", setTitle] = useState("");
  const [body = "", setBody] = useState("");

  const [selected_ticket, setSelectedTicket] = useState(null);
  const [count, setCount] = useState(1000);
  const [logs, setLogs] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [emailOpen, setEmailOpen] = useState(false);
  // Function to navigate to a client by ID
  const gotoUser = async (log) => {
    const obj = await getDocDataByRef(log.ref);
    setSelectedTicket(obj);
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handleSendEmail = async () => {
    const token = await getOrRefreshFirebaseToken();

    await sendRequestResolved(selected_ticket.id, body, token, prefix);
    let response = {
      admin_user_email: userData.email,
      date: getFlutterTime(),
      suivi: body,
    };
    await updateDocDataFieldApi(
      selected_ticket.ref,
      "admin_response",
      response,
      prefix
    );

    handleClickVariant("Message envoyé avec succès", "success");
    setEmailOpen(false);
  };

  const handleResolved = async (log) => {
    await updateDocDataFieldApi(log.ref, "status", "resolved", prefix);
    await updateDocDataFieldApi(
      log.ref,
      "admin_user_email",
      userData.email,
      prefix
    );
    handleClickVariant("Ticket résolu", "success");
    handleFetchData();
  };

  const handleBlocked = async (log) => {
    await updateDocDataFieldApi(log.ref, "status", "blocked", prefix);
    await updateDocDataFieldApi(
      log.ref,
      "admin_user_email",
      userData.email,
      prefix
    );
    handleClickVariant("Ticket bloqué", "success");
    handleFetchData();
  };

  const handleDeleteLog = async (log) => {
    await deleteDocApi(log.ref, prefix);
    handleFetchData();
  };
  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserById(currentUser.uid);

      // Fetch organization data using the user's org reference
      const org = await getOrgById(user.org_id);
      let tickets = [];
      let filters = [];

      filters = [];
      // Fetch clients associated with the user's organization
      tickets = await queryCollection(
        "support_request",
        filters,
        500,
        "date",
        "desc"
      );

      // Transform clients into table format (rows and columns)
      const { rows, columns } = transformTicketsToTable(tickets, theme, "");

      // Update state if the user data is new or changed

      setUserData(user);
      setOrgData(org);
      setLogs(logs);
      setRows(rows);
      setColumns(columns);

      // Set options for the search bar (client names)
      setOptions(tickets.map((log) => log.email));
    }
  };

  const handleSearchChange = (valuee) => {
    let value = searchValue;
    if (valuee) {
      value = valuee;
    } else {
      value = "";
    }

    const { rows, columns } = transformAppLogsToTable(logs, theme, value);

    setRows(rows);
    setColumns(columns);
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  // Render the client data
  return (
    <div className="flex flex-col h-screen w-full p-4">
      <Modal1 isOpen={emailOpen} onClose={() => setEmailOpen(false)}>
        <div className="flex flex-col gap-4 bg-white p-4 rounded-xl w-c500">
          <MLTFGPT1
            value={body}
            onChange={(e) => setBody(e.target.value)}
            label="Body"
            rows={10}
          />
          <PrimaryButton onClick={handleSendEmail}>Send</PrimaryButton>
        </div>
      </Modal1>
      <div className=" flex flex-row w-full h-full">
        <div className="flex flex-col h-full w-full" y={10}>
          <div className="text-hx font-medium flex flex-row gap-4">
            <div>Tickets support </div>
            <TextField2
              className="max-w-c100"
              label="Nombre de logs"
              value={count}
              onChange={(e) => setCount(e.target.value)}
            />
            <SecondaryButton
              onClick={() => {
                handleFetchData();
              }}
            >
              Apply
            </SecondaryButton>
          </div>
          <Space y={10} />
          <div className="flex flex-row w-full items-center">
            {/* Search Bar */}
            <div className="flex flex-row w-c700  gap-2 items-center">
              <TextField2
                label="Chercher"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <PrimaryButton
                disabled={searchValue == ""}
                className="h-fit "
                onClick={() => handleSearchChange(searchValue)}
              >
                Filtrer
              </PrimaryButton>
              <PrimaryButton
                className="h-fit "
                onClick={() => {
                  setSearchValue("");
                  handleSearchChange(null);
                }}
              >
                Reset
              </PrimaryButton>
            </div>
          </div>

          {/* DataGrid displaying the clients */}
          <div className="w-full h-full pb-8 overflow-auto mb-4 mt-3">
            <div className="h-full  min-h-6 max-w-c600">
              <DataGridFull
                rows={rows}
                columns={columns}
                onClick={gotoUser}
                initial_sort_field="date"
                initial_asc="desc"
              />
            </div>
          </div>
        </div>

        <Divider orientation="vertical" />
        <div className="flex-grow w-full  h-full p-2 pb-10  mb-8 text-black ">
          {selected_ticket && (
            <div className="flex  bg-white rounded-xl flex-col  h-full p-2 gap-1 text-h4 overflow-auto">
              <div className="flex flex-row items-center  mb-2 ">
                {selected_ticket.status === "open" && (
                  <div className="  text-shadow_50 bg-orange-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                    Ouvert
                  </div>
                )}
                {selected_ticket.status === "resolved" && (
                  <div className="  text-shadow_50 bg-green-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                    Resolved
                  </div>
                )}
                {selected_ticket.status === "blocked" && (
                  <div className="  text-shadow_50 bg-red-100 px-2 text-h2  w-fit  flex rounded-full h-5 items-center ">
                    Blocked
                  </div>
                )}
              </div>
              <SecondaryButton
                className="h-fit w-fit"
                onClick={() => handleResolved(selected_ticket)}
              >
                Set as resolved
              </SecondaryButton>
              <SecondaryButton
                className="h-fit w-fit"
                onClick={() => handleBlocked(selected_ticket)}
              >
                Set as blocked
              </SecondaryButton>
              <SecondaryButton
                className="h-fit w-fit"
                onClick={() => setEmailOpen(true)}
              >
                Send a resolution email
              </SecondaryButton>
              <div className="text-h4 font-medium my-3">Details</div>
              <div className="flex flex-col gap-1">
                <div className="text-blue-500">
                  {selected_ticket.admin_user_email}
                </div>
                <div>{selected_ticket.email}</div>
                <div>{selected_ticket.oid}</div>{" "}
                <div>{selected_ticket.parsed_date}</div>{" "}
                <div>{selected_ticket.ticket_num}</div>
                <div className="mt-2" style={{ whiteSpace: "pre-line" }}>
                  {selected_ticket.message}
                </div>
                {selected_ticket.admin_response && (
                  <div className="mt-4 text-shadow_50">
                    <div>{selected_ticket.admin_response.admin_user_email}</div>
                    <div>
                      {new Date(
                        selected_ticket.admin_response.date
                      ).toLocaleString()}
                    </div>
                    <div style={{ whiteSpace: "pre-line" }}>
                      {selected_ticket.admin_response.suivi}
                    </div>
                  </div>
                )}
              </div>
              <Space y={10} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SupportRequests;
